<template>
  <div class="flex h-screen bg-gray-900 text-white">
    <!-- Sidebar -->
    <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg border-r border-gray-700">
      <div class="flex items-center justify-center">
        <img src="@/assets/logo.svg" alt="Vultric Logo" class="h-20" />
      </div>
      <Navbar />
    </aside>

    <!-- Main Content -->
    <div class="flex-1 flex flex-col">
      <!-- Header -->
      <header class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md border-b border-gray-700">
        <h2 class="text-xl font-semibold">Servers</h2>
      </header>

      <main class="flex-1 overflow-y-auto p-6 space-y-6">
        <div class="bg-gray-800 rounded-lg shadow p-6 border border-gray-700">
          <h3 class="text-lg font-semibold mb-4">Server List</h3>

          <!-- Search Bar -->
          <div class="mb-4">
            <input
              type="text"
              v-model="searchQuery"
              placeholder="Search servers by name, IP, or OS..."
              class="w-full p-3 rounded-lg bg-gray-900 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
          </div>

          <table class="w-full text-left border-collapse">
            <thead>
              <tr class="bg-gray-700">
                <th class="p-3 rounded-tl-lg">ID</th>
                <th class="p-3">Name</th>
                <th class="p-3">IP</th>
                <th class="p-3">Status</th>
                <th class="p-3">Operating System</th>
                <th class="p-3">Location</th>
                <th class="p-3">Node ID</th>
                <th class="p-3 rounded-tr-lg">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="server in filteredServers"
                :key="server.id"
                class="border-t border-gray-700 hover:bg-gray-700 transition cursor-pointer"
              >
                <td class="p-3 font-semibold">#{{ server.id }}</td>
                <td class="p-3">{{ server.servername }}</td>
                <td class="p-3">{{ server.ipaddress }}</td>
                <td class="p-3">
                  <span
                    :class="server.status === 'Running' ? 'bg-green-600 text-white px-2 py-1 rounded' : 'bg-red-600 text-white px-2 py-1 rounded'"
                  >
                    {{ server.status }}
                  </span>
                </td>
                <td class="p-3">{{ server.osImage }}</td>
                <td class="p-3">{{ server.location }}</td>
                <td class="p-3">{{ server.nodeid }}</td>
                <td class="p-3">
                  <button
                    @click="viewServer(server.id)"
                    class="px-3 py-1 bg-blue-600 rounded-lg hover:bg-blue-700"
                  >
                    View
                  </button>
                </td>
              </tr>
              <tr v-if="filteredServers.length === 0">
                <td colspan="8" class="text-center py-4 text-gray-400">No servers found.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/adminnav.vue';
import axios from 'axios';

export default {
  name: "AdminServers",
  components: { Navbar },
  data() {
    return {
      servers: [],
      searchQuery: ''
    };
  },
  async mounted() {
    await this.fetchServers();
  },
  computed: {
    filteredServers() {
      if (!this.searchQuery) return this.servers;
      const query = this.searchQuery.toLowerCase();
      return this.servers.filter(server =>
        server.servername.toLowerCase().includes(query) ||
        server.ipaddress.toLowerCase().includes(query) ||
        server.osImage.toLowerCase().includes(query)
      );
    }
  },
  methods: {
    async fetchServers() {
      try {
        const response = await axios.get(
          'https://api.syniac.com:3000/api/admin/server/get',
          { withCredentials: true }
        );
        this.servers = response.data.servers;
      } catch (error) {
        console.error("Error fetching servers:", error);
      }
    },
    viewServer(serverID) {
      this.$router.push(`/admin/server/${serverID}`);
    }
  }
};
</script>
